import { formatPrice } from "../utils/formatPrice";

const ProductCard = ({
  product,
  onAddToCart,
  onOpenDetails,
  onToggleWishlist,
  cartQuantity = 0,
  isWishlisted = false,
}) => {
  return (
    <article className="product-card">
      <button className="product-image-wrap" type="button" onClick={() => onOpenDetails(product)}>
        <img src={product.image} alt={product.name} />
        <span className="product-badge">Bestseller</span>
        <span className="quick-view-label">Quick view</span>

        <span
          className={`heart-btn ${isWishlisted ? "active" : ""}`}
          role="button"
          tabIndex="0"
          aria-label={isWishlisted ? "Remove from wishlist" : "Add to wishlist"}
          onClick={(event) => {
            event.stopPropagation();
            onToggleWishlist(product.id);
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              event.stopPropagation();
              onToggleWishlist(product.id);
            }
          }}
        >
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20.8 4.6a5.5 5.5 0 00-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 00-7.8 7.8l1 1L12 21.2l7.8-7.8 1-1a5.5 5.5 0 000-7.8z" />
          </svg>
        </span>
      </button>

      <div className="product-meta">{product.category}</div>
      <h3>{product.name}</h3>
      <p className="product-description">{product.description}</p>

      <div className="product-benefits">
        {product.benefits.slice(0, 2).map((benefit) => (
          <span key={benefit}>{benefit}</span>
        ))}
      </div>

      <div className="rating-row">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="#D5A84F">
          <path d="M12 2l3.1 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.8 21 7 14.2l-5-4.9 6.9-1L12 2z" />
        </svg>
        <span>{product.rating}</span>
      </div>

      <div className="product-bottom">
        <p>{formatPrice(product.price)}</p>
        <button type="button" onClick={() => onAddToCart(product)}>
          {cartQuantity > 0 ? `Added (${cartQuantity})` : "Add to Cart"}
        </button>
      </div>
    </article>
  );
};

export default ProductCard;
